import _plugin_vue_export_helper_default from "../../_virtual/_plugin-vue_export-helper.js";
import ScalarColorModeToggleIcon_vue_vue_type_script_setup_true_lang_default from "./ScalarColorModeToggleIcon.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                              */
//#region src/components/ScalarColorModeToggle/ScalarColorModeToggleIcon.vue
var ScalarColorModeToggleIcon_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ScalarColorModeToggleIcon_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-8f507267"]]);
//#endregion
export { ScalarColorModeToggleIcon_default as default };

//# sourceMappingURL=ScalarColorModeToggleIcon.vue.js.map